// import { useEffect, useState } from "react";
import "./input_switch.scss";

const InputSwitch = (props) => {
    const toggleSwitch = () => {
        if (props.disabled) return;
        props.onClick(!props.isOn);
    };

    return (
        <div className={`form-group ${props.label ? "m-1" : ""} ${props.disabled ? 'disabled' : ''}`}>
            {props.label ? <label htmlFor={props.id}>{props.label}</label> : null}
            <div className="switch-row">
                <div className={`switch ${props.isOn ? 'on' : 'off'} ${props.disabled ? 'disabled' : ''}`}
                    onClick={toggleSwitch}>
                    <div className={`switch-button ${props.isOn ? 'switch-on' : 'switch-off'}`} />
                </div>
                <div className={`switch-description ${props.isOn ? 'text-on' : 'text-off'} ${props.disabled ? 'disabled-text' : ''}`}>
                    Activate
                </div>
            </div>
        </div>
    );
};

export default InputSwitch;